import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

export default function InformationInstitute() {
  useSEO(seoConfig.informationinstitute);

  return (
    <section className="contacts about">
      <Breadcrumbs />

      <h1 className="contacts__title history__title">
        Сведения об образовательной организации
      </h1>
      <div>
        {/* <h2 className="about-nii__title antiCorruption__title">1 пункт</h2> */}
        {/* <p>Основные сведения</p> */}
        <table className="contacts__table">
          <tbody>
            <tr className="contacts__line">
              <th className="contacts__caption" colSpan={2}>
                Информация об организации
              </th>
            </tr>
            <tr className="contacts__line">
              <td className="contacts__cell">
                Полное наименование (в соответствии с уставов)
              </td>
              <td className="contacts__cell">
                Государственное бюджетное учреждение Свердловской области
                «Уральский научно-исследовательский институт дерматовенерологии
                и иммунопатологии»
              </td>
            </tr>
            <tr className="contacts__line">
              <td className="contacts__cell">
                Сокращенное наименование (в соответствии с уставом)
              </td>
              <td className="contacts__cell">ГБУ СО «УрНИИДВиИ»</td>
            </tr>
            <tr className="contacts__line">
              <td className="contacts__cell">Место нахождения</td>
              <td className="contacts__cell">
                г. Екатеринбург, ул. Щербакова, 8
              </td>
            </tr>
            <tr className="contacts__line">
              <td className="contacts__cell">Почтовый адрес</td>
              <td className="contacts__cell">
                620076, Россия, г. Екатеринбург, ул. Щербакова, 8
              </td>
            </tr>
            <tr className="contacts__line">
              <td className="contacts__cell">Адрес электронной почты</td>
              <td className="contacts__cell contacts__mail">
                <a
                  href="mailto:nauka-urnii@mail.ru"
                  className="contacts__table-tel"
                >
                  nauka-urnii@mail.ru
                </a>
              </td>
            </tr>
            <tr className="contacts__line">
              <td className="contacts__cell">
                ФИО и должность руководителя организации
              </td>
              <td className="contacts__cell">
                Кунгуров Николай Васильевич <br></br>директор ГБУ СО
                «УрНИИДВиИ», Заслуженный врач РФ, доктор медицинских наук,
                профессор
              </td>
            </tr>
            <tr className="contacts__line">
              <td className="contacts__cell">Дата создания института</td>
              <td className="contacts__cell">Декабрь 1931 года</td>
            </tr>
            <tr className="contacts__line">
              <td className="contacts__cell">График работы организации</td>
              <td className="contacts__cell">
                Понедельник - Пятница 09:00-17:00
              </td>
            </tr>
            <tr className="contacts__line">
              <td className="contacts__cell">Научно-образовательный отдел</td>
              <td className="contacts__cell">
                <Link
                  to="/education/residency/scientific-educational"
                  className="structure__download-link licenses__link"
                >
                  Просмотр
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <ul className="list">
          <li className="privacy__text">
            <Link
              to="/about/structure"
              className="structure__download-link licenses__link"
            >
              Структура института
            </Link>
          </li>
          <li className="privacy__text">
            <Link
              to="/about/controls"
              className="structure__download-link licenses__link"
            >
              Органы управления
            </Link>
          </li>
          <li className="privacy__text">
            <a
              href="/files/education/lic_obr2016.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link licenses__link"
            >
              Лицензия на образовательную деятельность
            </a>
          </li>
          <li className="privacy__text">
            <a
              href="/files/licenses/licenziy_01.16.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link licenses__link"
            >
              Лицензия на медицинскую деятельность
            </a>
          </li>
          <li className="privacy__text">
            <a
              href="/files/licenses/1_ISO_Certificate.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link licenses__link"
            >
              Сертификат ISO 9001
            </a>
            <a
              href="/files/licenses/2_ISO_Certificate.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link licenses__link"
            >
              Сертификат ISO 9001
            </a>
            <a
              href="/files/licenses/3_ISO_Certificate.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link licenses__link"
            >
              Сертификат ISO 9001
            </a>
            <a
              href="/files/licenses/4_ISO_Certificate.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link licenses__link"
            >
              Сертификат ISO 9001
            </a>
          </li>
          <li className="privacy__text">
            <a
              href="/files/education/svid_gos_akred.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link licenses__link"
            >
              Свидетельство о государственной аккредитации
            </a>
          </li>
          <li className="privacy__text">
            <a
              href="/files/education/Extract_from_the_register_dated_04.08.2026.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link licenses__link"
            >
              Выписка из реестра заключений о соответствии организации,
              осуществляющей образовательную деятельность по профессиональным
              образовательным программам медицинского образования,
              фармацевтического образования, требованиям к кадровому и
              материально-техническому обеспечению образовательной деятельности
              в части практической подготовки обучающихся
            </a>
          </li>
        </ul>
      </div>

      <div>
        <ul className="list">
          <li className="privacy__text">
            <a
              href="/files/residency/uchebniy_plan.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link licenses__link"
            >
              Учебный план
            </a>
          </li>
        </ul>
        <ul className="list">
          <li className="privacy__text">
            <a
              href="/files/residency/opop_dv.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link licenses__link"
            >
              Основная профессиональная образовательная программа высшего
              образования – программа подготовки кадров высшей квалификации в
              ординатуре специальность 31.08.32 дерматовенерология
            </a>
          </li>
        </ul>
        <ul className="list">
          <li className="privacy__text">
            <Link
              to="/education/residency/regulatory-documents"
              className="structure__download-link licenses__link"
            >
              Нормативные документы
            </Link>
          </li>
        </ul>
        <ul className="list">
          <li className="privacy__text">
            <Link
              to="/education/residency/educational-program"
              className="structure__download-link licenses__link"
            >
              Образовательная программа ординатуры
            </Link>
          </li>
        </ul>
      </div>

      <div>
        <ul className="list">
          <li className="privacy__text">
            <Link
              to="/education/residency/contingent-students"
              className="structure__download-link licenses__link"
            >
              Контингент обучающихся в ординатуре
            </Link>
          </li>
        </ul>
      </div>

      <div>
        <h2 className="about-nii__title antiCorruption__title">
          Образовательный процесс осуществляется на русском языке.
          Образовательная организация имеет договоры о международном
          сотрудничестве с:
        </h2>
        <ul className="list">
          <li className="privacy__text">
            <p>
              Кыргызская государственная медицинская академия им. А.К. Ахунбаева
            </p>
          </li>
          <li className="privacy__text">
            <p>
              Государственное образовательное учреждение с ВПО
              Кыргызско-Российский Славянский университет им. первого Президента
              РФ Б.Н.Ельцина
            </p>
          </li>
          <li className="privacy__text">
            <p>
              Учреждение образования "Белорусский государственный медицинский
              университет"
            </p>
          </li>
        </ul>
      </div>
      {/*
      <div>
        <h2 className="about-nii__title antiCorruption__title">6 пункт</h2>
        <li></li>
      </div> */}

      <div>
        <ul className="list">
          <li className="privacy__text">
            <Link
              to="/education/residency/scientific-educational"
              className="structure__download-link licenses__link"
            >
              Контакты
            </Link>
          </li>
        </ul>
      </div>

      <div>
        <ul className="list">
          <li className="privacy__text">
            <Link
              to="/education/teaching-staff"
              className="structure__download-link licenses__link"
            >
              Профессорско-преподавательский состав
            </Link>
          </li>
        </ul>
      </div>

      {/* <div>
        <h2 className="about-nii__title antiCorruption__title">9 пункт</h2>
        <li></li>
      </div>

      <div>
        <h2 className="about-nii__title antiCorruption__title">10 пункт</h2>
        <li></li>
      </div>

      <div>
        <h2 className="about-nii__title antiCorruption__title">11 пункт</h2>
        <li></li>
      </div> */}

      <div>
        <ul className="list">
          <li className="privacy__text">
            <Link
              to="/education/admissions-committee"
              className="structure__download-link licenses__link"
            >
              Приемная комиссия
            </Link>
          </li>
        </ul>
      </div>

      {/* <div>
        <h2 className="about-nii__title antiCorruption__title">13 пункт</h2>
        <ul className="list">
          <li className="privacy__text">
            <Link to="education/admissions-committee" className="structure__download-link licenses__link">
              Приемная комиссия
            </Link>
          </li>
        </ul>
      </div> */}

      {/* <div>
        <h2 className="about-nii__title antiCorruption__title">14 пункт</h2>
        <li></li>
      </div>

      <div>
        <h2 className="about-nii__title antiCorruption__title">15 пункт</h2>
        <li></li>
      </div>

      <div>
        <h2 className="about-nii__title antiCorruption__title">16 пункт</h2>
        <li></li>
      </div>

      <div>
        <h2 className="about-nii__title antiCorruption__title">17 пункт</h2>
        <li></li>
      </div>

      <div>
        <h2 className="about-nii__title antiCorruption__title">18 пункт</h2>
        <li></li>
      </div> */}

      {/* <div>
        <ul className="list">
          <li className="privacy__text">
            <Link
              to="/education"
              className="structure__download-link licenses__link"
            >
              Образование
            </Link>
          </li>
        </ul>
      </div> */}

      {/* <div>
        <h2 className="about-nii__title antiCorruption__title">20 пункт</h2>
        <ul className="list">
          <li className="privacy__text">
            <Link to="education" className="structure__download-link licenses__link">
              Образование
            </Link>
          </li>
        </ul>
      </div> */}

      {/* <div>
        <h2 className="about-nii__title antiCorruption__title">21 пункт</h2>
        <li></li>
      </div> */}

      {/* <div>
        <ul className="list">
          <li className="privacy__text">
            <a
              href="/files/education/FHD_plan_2026.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link licenses__link"
            >
              План ФХД
            </a>
          </li>
        </ul>
      </div> */}

      <div>
        <ul className="list">
          <li className="privacy__text">
            <Link
              to="/education"
              className="structure__download-link licenses__link"
            >
              Список локальных нормативных актов по вопросам организации и
              осуществления образовательной деятельности 2026
            </Link>
          </li>
        </ul>
      </div>

      {/* <div>
        <h2 className="about-nii__title antiCorruption__title">24 пункт</h2>
        <li></li>
      </div>

      <div>
        <h2 className="about-nii__title antiCorruption__title">25 пункт</h2>
        <li></li>
      </div>

      <div>
        <h2 className="about-nii__title antiCorruption__title">26 пункт</h2>
        <li></li>
      </div> */}
    </section>
  );
}
